import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { DetailsPageComponent } from './details.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: DetailsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class DetailsPageRoutingModule {}
